export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function niceTicks(maxValue, count = 4) {
  const max = Math.max(1, Number(maxValue || 0));
  const step = Math.pow(10, Math.floor(Math.log10(max / count)));
  const niceStep = Math.ceil((max / count) / step) * step;
  const ticks = [];
  for (let i = 0; i <= count; i++) ticks.push(i * niceStep);
  return { ticks, max: ticks[ticks.length - 1] };
}

export function formatInr(n) {
  try {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n || 0));
  } catch {
    return `₹${Number(n || 0).toFixed(2)}`;
  }
}


